module.exports = __webpack_public_path__ + "static/media/minahan_pascual_lentz.66a7bd99.gif";